<template>
  <v-row dense>
    <v-col>
      <v-btn
        v-if="isMobile()"
        fab
        right
        bottom
        fixed
        color="primary"
        large
        @click="irTelaAddCliente()"
        ><v-icon>mdi-plus</v-icon></v-btn
      >
      <v-btn
        v-else
        rounded        
        color="info"        
        height="33"
        @click="irTelaAddCliente()"               
        large
        ><v-icon left>mdi-plus</v-icon> Adicionar Cliente</v-btn
      >
    </v-col>
  </v-row>
</template>

<script>
export default {
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
    irTelaAddCliente() {
      this.$router.push("/clientes/adicionar");
    },
  },
};
</script>

<style>
</style>